import React, { useState, useEffect } from "react";
import { Link } from "@quintype/components";
import { string, object, bool, func } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import {
  TwitterIcon,
  FacebookIcon,
  Email,
  // Print,
  CopyLink,
  // Instagram,
  Linkedin
} from "../../atoms/icons/StoryPageIcons";
import { staticTexts } from "../../utils/Translate";
import HamburgerIcon from "../../atoms/icons/hamburger";
import WatsAppIcon from "../../atoms/icons/WatsAppIcon";

import "./shareAllTemplate.m.css";

const ShareAllTemplate = ({
  isBreakingNews,
  twitterUrl,
  fbUrl,
  mailtoUrl,
  linkedinUrl,
  publisherUrl,
  url,
  publisherAttributes,
  onScroll,
  toggleShare2,
  toggleShare,
  whatsappUrl,
  fullUrl
}) => {
  const [isMobile, setIsMobile] = useState(false);
  const [showCopy, setShowCopy] = useState(false);

  useEffect(() => {
    global.deviceWidth < 876 && setIsMobile(!isMobile);

    const interval = setInterval(() => {
      setShowCopy(false);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  const copyToClipboard = storyUrl => {
    const textArea = document.createElement("textarea");
    document.body.appendChild(textArea);
    textArea.value = storyUrl;
    textArea.select();
    document.execCommand("copy");
    document.body.removeChild(textArea);

    setShowCopy(true);
  };

  // const printPage = sURL => {
  //   if (isBreakingNews) {
  //     var myWindow = window.open("", "");
  //     myWindow.document.write(
  //       `<iframe name="contentwin" src=${sURL} scrolling="yes" frameborder="0" height="100%" width="100%"></iframe>`
  //     );

  //     myWindow.focus();
  //     myWindow.print();
  //   } else window.print();
  // };

  return (
    <div
      styleName={`icon-wrapper ${publisherAttributes.lang === "en" ? "en-icon-wrapper" : ""}`}
      className="share-all-template"
    >
      <div>
        {isMobile && (
          <span onClick={onScroll ? toggleShare2 : toggleShare}>
            <HamburgerIcon isNavbarOpen={true} />
          </span>
        )}
        <div styleName="share-text">{staticTexts(publisherAttributes.lang).share}</div>
        <div styleName="share-icon">
          <Link href={fbUrl} target="_blank" rel="noopener noreferrer">
            <FacebookIcon />{" "}
            <span styleName="share-title">{staticTexts(publisherAttributes.lang).shareOnFacebook}</span>
          </Link>
        </div>
        <div styleName="share-icon email-icon">
          <Link href={mailtoUrl} target="_blank" rel="noopener noreferrer">
            <Email /> <span styleName="share-title">{staticTexts(publisherAttributes.lang).pleaseEmail}</span>
          </Link>
        </div>
        <div styleName="share-icon copy-icon">
          <input type="hidden" id="input-url" value="Copied!"></input>
          <span
            onClick={e => copyToClipboard(isBreakingNews ? publisherUrl + "/" + url : fullUrl)}
            styleName="copy-link"
          >
            <CopyLink /> <span styleName="share-title">{staticTexts(publisherAttributes.lang).copyLink}</span>
            {showCopy && <span styleName="copy-popup">Link Copied</span>}
          </span>
        </div>
      </div>
      <div styleName="second-column">
        <div styleName="share-icon">
          <Link href={linkedinUrl} target="_blank" rel="noopener noreferrer" className="linkedin">
            <Linkedin /> <span styleName="share-title">{staticTexts(publisherAttributes.lang).shareOnLinkedIn}</span>
          </Link>
        </div>
        <div styleName="share-icon">
          <Link href={twitterUrl} target="_blank" rel="noopener noreferrer">
            <TwitterIcon /> <span styleName="share-title">{staticTexts(publisherAttributes.lang).shareOnTwitter}</span>
          </Link>
        </div>
        {/* <div styleName="share-icon">
          {window && (
            <span onClick={e => printPage(publisherUrl + "/" + url)} styleName="print">
              <Print /> <span styleName="share-title">{staticTexts(publisherAttributes.lang).print}</span>
            </span>
          )}
        </div> */}
        <div styleName="share-icon">
          <Link href={whatsappUrl} target="_blank" rel="noopener noreferrer">
            <WatsAppIcon bgColor="#4AC959" fontColor="#ffffff" />
            <span styleName="share-title">{staticTexts(publisherAttributes.lang).shareOnWatsapp}</span>
          </Link>
        </div>
      </div>
    </div>
  );
};

ShareAllTemplate.propTypes = {
  twitterUrl: string,
  fbUrl: string,
  mailtoUrl: string,
  linkedinUrl: string,
  publisherUrl: string,
  url: string,
  publisherAttributes: object,
  onScroll: bool,
  toggleShare2: func,
  toggleShare: func,
  isBreakingNews: bool,
  whatsappUrl: string,
  fullUrl: string
};

const mapStateToProps = state => {
  return {
    publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {})
  };
};

export default connect(mapStateToProps, null)(ShareAllTemplate);
